module.exports = __webpack_public_path__ + "images/emoji/ant.931f6816ddbc16349d02.png";